module.exports = __webpack_public_path__ + "img/2.52d83e7c.jpg";